import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Logout from "layouts/authentication/logout";
import ChangePassword from "layouts/authentication/change-password";
import ForgotPassword from "layouts/authentication/forgot-password";
import ResetPassword from "layouts/authentication/reset-password";
import Faqs from "layouts/faqs";
import AddFaqsForm from "layouts/faqs/addFaqs";
import EditFaqsForm from "layouts/faqs/editFaqs";
import Pages from "layouts/pages";
import AddPage from "layouts/pages/addPage";
import EditPage from "layouts/pages/editPage";
import Users from "layouts/users";
import Services from "layouts/services";
import AddServices from "layouts/services/addService";
import EditServices from "layouts/services/editService";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Manage FAQs",
    key: "faqs",
    icon: <Icon fontSize="small">quiz</Icon>,
    route: "/faqs",
    component: <Faqs />,
    protected: true,
  },
  {
    name: "Add FAQs",
    key: "add_faqs",
    route: "/faqs/add-faqs",
    component: <AddFaqsForm />,
    protected: true,
  },
  {
    name: "Edit FAQs",
    key: "editFaqs",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/faqs/:id",
    component: <EditFaqsForm />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Manage CMS",
    key: "page",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/page",
    component: <Pages />,
    protected: true,
  },
  {
    name: "Add Page",
    key: "add-page",
    route: "/page/add",
    component: <AddPage />,
    protected: true,
  },
  {
    name: "Edit Page",
    key: "edit-page",
    route: "/page/:id",
    component: <EditPage />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Manage Services",
    key: "service",
    icon: <Icon fontSize="small">build</Icon>,
    route: "/service",
    component: <Services />,
    protected: true,
  },
  {
    name: "Add Service",
    key: "add-service",
    route: "/service/add",
    component: <AddServices />,
    protected: true,
  },
  {
    name: "Edit Service",
    key: "edit-service",
    route: "/service/:id",
    component: <EditServices />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Manage Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <Users />,
  },
  {
    name: "Login",
    key: "sign-in",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    protected: false,
  },
  {
    type: "collapse",
    name: "Change Password",
    key: "ChangePassword",
    icon: <Icon fontSize="small">lock</Icon>,
    route: "/authentication/change-password",
    component: <ChangePassword />,
    protected: true,
  },
  {
    name: "Forgot Password",
    key: "ForgotPassword",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/authentication/forgot-password",
    component: <ForgotPassword />,
    protected: false,
  },
  {
    name: "Reset Password",
    key: "ResetPassword",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
    protected: false,
  },
  {
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/logout",
    component: <Logout />,
  },

  {
    type: "route",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/authentication/forgot-password",
    component: <ForgotPassword />,
    noCollapse: true,
    hidden: true, // so it's not shown in navbar
  },
];

export default routes;
